import { Link } from 'react-router-dom'

interface NewsCardProps {
  article: {
    slug: string
    title: string
    headline?: string
    description?: string
    source: string
    source_url: string
    image_url?: string
    published_at?: string
    categories?: string[]
  }
  sport: string
}

export function NewsCard({ article, sport }: NewsCardProps) {
  return (
    <Link
      to={`/${sport}/news/${article.slug}`}
      className="card group hover:border-accent/30 transition-colors overflow-hidden flex flex-col"
    >
      {article.image_url && (
        <div className="aspect-video overflow-hidden bg-pitch-800">
          <img
            src={article.image_url}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            loading="lazy"
          />
        </div>
      )}
      <div className="p-4 flex-1 flex flex-col">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-[10px] font-bold uppercase tracking-wider text-accent bg-accent/10 px-1.5 py-0.5 rounded">
            {article.source}
          </span>
          {article.published_at && (
            <span className="text-xs text-slate-500">
              {new Date(article.published_at).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
              })}
            </span>
          )}
        </div>
        <h3 className="text-sm font-semibold text-slate-200 group-hover:text-white line-clamp-2 mb-1">
          {article.title}
        </h3>
        {article.description && (
          <p className="text-xs text-slate-400 line-clamp-2 mt-auto">
            {article.description}
          </p>
        )}
      </div>
    </Link>
  )
}
